import { config } from './config';
import { demoDataSource } from './sources/mock';
import { restDataSource } from './sources/rest';
import type { CompilacoesDataSource } from './types';

/**
 * Composition root da camada de dados: a escolha entre API real e demo acontece
 * uma única vez, aqui. Nenhuma tela importa `restDataSource` ou `demoDataSource`
 * diretamente — todas recebem `CompilacoesDataSource`.
 */
export const dataSource: CompilacoesDataSource = config.dataSource === 'rest' ? restDataSource : demoDataSource;

export * from './types';
export { config, PRODUTO_PADRAO, PRODUTOS } from './config';
